<template>
  <v-dialog persistent :value="show" max-width="290">
    <v-card>
      <v-card-title>
        {{ $t('common.confirm_skip_title') }}
      </v-card-title>
      <v-card-text>{{ $t('common.confirm_skip_subtitle') }}</v-card-text>
      <v-card-actions class="justify-end">
        <Button
          plain
          color="grey"
          :text="$t('common.button.cancel')"
          @click="$emit('cancel')"
        />
        <Button
          plain
          color="danger"
          :text="$t('common.button.confirm')"
          @click="$emit('confirm')"
        />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import Button from '@/components/UI/Button'
export default {
  name: 'DeleteConfirmation',
  components: {
    Button,
  },
  props: {
    show: Boolean,
  },
}
</script>
